import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
// import toaster from 'utils/toaster';

export interface IResendInvitesData {
  user_id: number | null;
}

const resendInvite = (postData: IResendInvitesData) => {
  return http().post(endpoints.employee.resendInvite, postData);
};

export function useResendInvite() {
  return useMutation({ mutationFn: resendInvite });
}
